<div class="selection-group flex flex-row flex-wrap gap-2.5" [ngClass]="{ overflow: isProductCard }">
  <div class="selection flex-none" *ngFor="let option of options; let i = index">
    <input
      id="{{ name }}-{{ i }}"
      [name]="name"
      type="radio"
      [value]="option"
      [(ngModel)]="selected"
      (ngModelChange)="onChange($event)"
    />
    <div
      class="selector"
      *ngIf="isVisible(option)"
      [ngClass]="{ 'selector-checked': this.selected === option && isProductCard, 'pink-selector': isProductCard }"
      (click)="clickInput(name + '-' + i)"
    >
      <img
        *ngIf="galleries?.[option]?.[0]?.small; else label"
        [src]="galleries[option][0]?.small"
        class="img-selector"
        [tooltip]="option"
        #tooltip="tooltip"
      />
      <div class="discount-div" *ngIf="getVariantDiscount(option) > 0">
        <span>-{{ getVariantDiscount(option) }}%</span>
      </div>
    </div>
    <ng-template #label>
      <ng-container *ngIf="isVisible(option)">
        <label for="{{ name }}-{{ i }}" [ngClass]="{ disabled: isDisabled(option) }">{{ option }}</label>
      </ng-container>
    </ng-template>
  </div>
</div>
